import { useMemo } from 'react';
import { useSearchParams } from 'react-router';
import { translate } from '../../../utils';

export default function useWelcomeBackOverallStatus() {
  const [searchParams] = useSearchParams();
  const overallStatusText = useMemo(() => {
    const identityStatus = searchParams.get('identityStatus');
    const bankAccountStatus = searchParams.get('bankAccountStatus');
    if (
      identityStatus === 'OCR_IN_PROGRESS' &&
      bankAccountStatus === 'PSD2_PAYMENT_SENT_WITH_INCOME'
    ) {
      return translate('welcome_back.overall_status_message');
    }

    if (
      identityStatus === 'APPROVED' &&
      bankAccountStatus === 'PSD2_PAYMENT_SENT_WITH_INCOME'
    ) {
      return translate('welcome_back.overall_status_message');
    }

    if (
      identityStatus === 'OCR_IN_PROGRESS' &&
      bankAccountStatus === 'APPROVED_WITH_INCOME'
    ) {
      return translate('welcome_back.overall_status_message');
    }

    return null;
  }, [searchParams]);

  return {
    overallStatusText,
  };
}
